'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import RightArrow from '@public/images/right-arrow-white.png'
import DarkRightArrow from '@public/images/dark-arrow-right.png'
import BusinessModals from '@components/BusinessModal/businessModals'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './features.module.scss'

const CATEGORY = {
  CUSTOMERS: 'customers',
}

const Index = ({ data }) => {
  const {
    taglineIconUrl,
    taglineText,
    headingText,
    FeatureList,
    actionText,
    formSnippet,
    category
  } = data?.data

  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  return (
    <div className={`${styles.main} ${styles[category]}`}>
      <div className={styles.container}>
        <div className={styles.tagline}>
          <Image
            src={taglineIconUrl?.data?.attributes?.url}
            alt={taglineText}
            width={16}
            height={16}
            loading="lazy"
          />
          <div className={styles.taglineText}>{taglineText}</div>
        </div>
        <h3 className={styles[`${category}MainText`]}>{headingText}</h3>
        <div className={styles.featuresContainer}>
          <div className={styles.featuresList}>
            {FeatureList?.map((feature, index) => (
              <div key={index} className={styles.feature}>
                <div className={styles.featureIconContainer}>
                  <Image
                    src={feature?.featureIconUrl?.data?.attributes?.url}
                    alt={feature?.heading}
                    width={16}
                    height={16}
                    loading="lazy"
                  />
                </div>
                <div className={styles.featureDetails}>
                  <div className={styles[`${category}FeatureHeading`]}>{feature?.heading}</div>
                  <div className={styles[`${category}FeatureDescription`]}>{feature?.description}</div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles[`${category}ActionLink`]} onClick={() => {
              sendEnterpriseEvent({ action_name: actionText, view_name: VIEW_LEAD_GEN_POPUP, action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP })
              setIsModalOpen(!isModalOpen)
            }}>
            <p>{actionText}</p>
            <Image
              src={category === CATEGORY.CUSTOMERS ? RightArrow : DarkRightArrow}
              alt="feature-title-logo"
              width={14}
              height={12}
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </div>
  )
}

export default Index
